import styled from './styled';
import type {CSS, CSSProperties} from './types';

export default styled;
export type {CSS, CSSProperties};
export {styled};
export {isFirefox} from './browserDetection';
export {REDUCED_MOTION, useReducedMotion} from './a11y';
export type {ColorMap} from './colors';
export {DarkModeProvider, useColors, useSetBackground} from './colors';
export type {FocusRingTone} from './focusRing';
export {
  FOCUS_RING_FADE,
  FOCUS_RING_WIDTH,
  focusRing,
  focusVisibleRing,
} from './focusRing';
export {useCSS} from './useCSS';
